// extracted by mini-css-extract-plugin
module.exports = {"link":"logo-module--link--1NlXN","logo":"logo-module--logo--3PymW","mobileLogo":"logo-module--mobile-logo--3FNm1","show":"logo-module--show--3u14W"};